export const ENUM_NEW_HOLDER = {
    HOLDER_SEARCH: 1,
    HOLDER_FORM: 2,
    HOLDER_CONFIRM_CODE: 3,
}